module.exports = __webpack_public_path__ + "static/media/product_innovation_and_development.01ad6579.png";